<!-- =========================================================================================
    File Name: TableSingleSelected.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
  <vx-card>
      <div class="p-6">
        <div class="flex flex-wrap items-center">
            <vs-input class="mr-4 mb-4" v-model="serverParams.instituteName" placeholder="학원명" @keyup.enter="onSearch"/>
            <vs-input class="mr-4 mb-4" v-model="serverParams.name" placeholder="이름" @keyup.enter="onSearch" />
            <vs-select class="mb-4" v-model="serverParams.status" name="item-status">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in statusOptions" />
            </vs-select>
            <vs-button class="mb-4 ml-4" color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            <!-- <vs-button class="mb-4 ml-4" @click="onSearch">검색</vs-button> -->
        </div>

        <vue-good-table
          mode="remote"
          isLoading.sync="isLoading"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-row-click="onRowClick"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 20
          }"
          :sort-options="{
            enabled: true,
            //initialSortBy: {field: 'studentName', type: 'asc'}
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          />
      </div>
    </vx-card> 
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'
import customFormatter from '../../../utils/customFormatter.js'

export default {
  components: {
    VueGoodTable,
    customFormatter
  },
  data () {
    return {
      isLoading: false,
      student_data : null,
      columns: [
        {
          label: '학원명',
          field: 'instituteName',
          type: 'name'
        },
        {
          label: '이름',
          field: 'name',
          type: 'name'
        },
        {
          label: '수강권한',
          field: 'licenseYn',
          type: 'name',
          tdClass: this.tdClassLincenseYn
        },
        {
          label: 'ID',
          field: 'studentID',
          type: 'name'
        },
        {
          label: '휴대폰번호',
          field: 'mobilephone',
          type: 'name',
          sortable: false
        },
        {
          label: '학년',
          field: 'schoolGrade',
          formatFn: this.schoolGrade,
          type: 'name'
        },
        {
          label: '마지막학습일',
          field: 'lastStudyDate',
          type: 'date',
          formatFn: this.createDate,
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        },
        {
          label: '가입일',
          field: 'createDate',
          type: 'date',
          formatFn: this.createDate,
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        },
        {
          label: '상태',
          field: 'status',
          formatFn: customFormatter.fomatterStudentStatus, 
          type: 'name',
          sortable: false,
          tdClass: this.tdClassStatus
        }
      ],
      rows: [],
      totalRecords: 0,
      //instituteName : '',
      //name: '',
      //status: '',
      serverParams: {
        page: 1,
        perPage: 20,
        field: 'InstituteName',
        type: 'ASC',
        instituteName: '',
        name: '',
        status: ''
      },
      statusOptions: [
        {
          value: '',
          text: '[상태]'
        },
        {
          value: '0',
          text: '수강중'
        },
        {
          value: '1',
          text: '퇴원'
        }
      ]
    }
  },
  
  methods: {
    tdClassStatus (row) {
      if (row.status === 1) {
        return 'text-danger'
      } else {
        return 'text-primary'
      }
    },
    tdClassLincenseYn (row) {
      if (row.licenseYn === 'Y') {
        return 'text-primary'
      } else {
        return 'text-danger'
      }
    },
    createDate (value) {
      if (value === null) return ''
      return value.split(' ')[0]
    },
    schoolGrade (value) {
      return `${value + 1}학년`
    },
    updateParams () {
      const newObj = Object.assign({}, this.serverParams)
      this.$store.dispatch('setStudentParams', newObj)
    },
    onRowClick (params) {
      const studentID = params.row.studentID
      this.$router.push(`/student/student-view/${studentID}`)
    },
    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },
    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },
    onSortChange (params) {
      this.serverParams.field = params[0].field
      this.serverParams.type = params[0].type
      this.loadItems()
    },
    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },

    async loadItems () { 
      try {
        this.updateParams()

        const { data } = await fetchData('student', this.serverParams)
        this.$vs.loading.close()

        this.totalRecords = data.count
        this.rows = data.list
      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    }
  },
  created () {
    const params = this.$store.getters.getStudentParams
    this.serverParams = Object.assign({}, params)
    this.loadItems()
  }
}
</script>
